import axios from "../utils/axios";

export const getShifts = () => {
    return axios.get(`/Shift/GetShift`);
};